import createVueApp from '@/common/createApp'

Styxie.Initializers.Businesses = {
  index: async(props) => {
    const { default: BusinessesIndex } = await import('@/vue_widgets/businesses/index.vue')
    createVueApp(BusinessesIndex, { props })
  },
  show: async(props) => {
    const { default: BusinessesShow } = await import('@/vue_widgets/businesses/show.vue')
    createVueApp(BusinessesShow, { props })
  },
  new: async(props) => {
    const { default: BusinessesForm } = await import('@/vue_widgets/businesses/form.vue')
    createVueApp(BusinessesForm, { props })
  },
  edit: async(props) => {
    const { default: BusinessesForm } = await import('@/vue_widgets/businesses/form.vue')
    createVueApp(BusinessesForm, { props })
  },
  assign_locations: async(props) => {
    const { default: LocationAssignment } = await import('@/vue_widgets/businesses/LocationAssignment.vue')
    createVueApp(LocationAssignment, { props })
  }
}
